import { Panel } from '@templates/index';
import { AudioControls } from './AudioControls';
import { SensitivityControls } from './SensitivityControls';
import { GestureReference } from './GestureReference';

export function SettingsPanel() {
  return (
    <>
      <Panel title="Audio">
        <AudioControls />
      </Panel>
      <Panel
        title="Gesture reference"
        description="Hand shapes the detectors are aiming for, with accept / reject examples."
      >
        <GestureReference />
      </Panel>
      <Panel title="Sensitivity" description="Calibrate gesture detection.">
        <SensitivityControls />
      </Panel>
    </>
  );
}
